import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const rawToken = localStorage.getItem('auth_app_token');
        if (rawToken) {
            try {
                const token = JSON.parse(rawToken);
                if (token?.value) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token.value}`
                        }
                    });
                }
            } catch (e) {
                console.error('No se pudo leer auth_app_token desde localStorage', e);
            }
        }
        return next.handle(request);
    }
}
